import React, { useState } from "react";
import { Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useNavigate } from "react-router-dom";
import AuthService from "../../Components/auth/AuthService";
import moment from "moment";
import { DATE_FORMAT, vehicleTypes } from "../../Components/common/constants";
import _ from "lodash";
import {
  useLoadingDispatch,
  showLoading,
  hideLoading,
} from "../../context/loadingContext";
import { EditFilled, PlusCircleFilled, SearchOutlined } from "@ant-design/icons";
import { Space, Table, Tag, Button as AntButton, DatePicker as AntDate } from "antd/es";
import dayjs from "dayjs";
import { showMessage } from "../../Components/Utils/message";

const useStyles = makeStyles((theme) => ({
  antAddIcon: {
    "& .anticon-plus-circle:hover": {
      color: "#4096ff !important"
    }
  },
}));

const Auth = new AuthService();

export default function RoasterList() {
  const classes = useStyles();
  const navigate = useNavigate();
  var layoutDispatch = useLoadingDispatch();

  const [roasters, setRoasters] = React.useState([]);
  const [startDate, setStartDate] = React.useState(null);
  const [endDate, setEndDate] = React.useState(null);


  const roasterColumns = [
    {
      title: 'Date',
      dataIndex: 'roaster_date',
      key: 'roaster_date',
      width: 135,
      render: (text) => {
        return text && dayjs(text).format(DATE_FORMAT);
      },
    },
    {
      title: 'Vehicles',
      width: '500px',
      render(record) {
        return (
          record?.vehicle_roasters.map((vehicle, index) => (
            <Space>
              <Tag style={{ margin: '4px' }} color="blue" key={index}>
                {vehicle?.registration_number}
              </Tag>
            </Space>
          ))
        );
      }
    },
    {
      title: 'Drivers',
      width: '500px',
      render(record) {
        return (
          record?.driver_roasters.map((vehicle, index) => (
            <Tag style={{ margin: '4px' }} color={"geekblue"} key={index}>
              {vehicle?.driver_name}
            </Tag>
          ))
        );
      }
    },
    {
      title: 'Helpers',
      width: '300px',
      render(record) {
        return (
          record?.helper_roasters.map((vehicle, index) => (
            <Tag style={{ margin: '4px' }} key={index}>
              {vehicle?.helper_name}
            </Tag>
          ))
        );
      }
    },
    {
      title: 'Action',
      key: 'action',
      align: "right",
      dataIndex: '',
      render(record) {
        return (
          <div >
            <EditFilled onClick={() => handleRowClick(record.id)} style={{ fontSize: '25px', cursor: "pointer", color: "#006cb8" }} />
          </div>
        );
      },
    },
  ];

  React.useEffect(() => {
    let date = new Date();
    let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    setStartDate(firstDay);
    setEndDate(lastDay);

    showLoading(layoutDispatch);
    Auth.post(`/roaster/roasters`, {
      start_date: moment(firstDay).format("YYYY-MM-DD"),
      end_date: moment(lastDay).format("YYYY-MM-DD"),
    })
      .then((res) => {
        hideLoading(layoutDispatch);
        if (res.ack) {
          let roasters1 = res.roasters;

          let roasters2 = [];
          roasters1.map((roaster) => {
            let check = roasters2.filter(
              (r) => r.roaster_date == roaster.roaster_date
            );
            if (check.length > 0) {
              if (roaster.type == 1) {
                // vehicle
                let vehicle_type = _.find(vehicleTypes, function (o) {
                  return o.id == roaster.record_type;
                });
                check[0].vehicle_roasters.push({
                  vehicle_id: roaster.object_id,
                  registration_number:
                    roaster.object_title + " (" + vehicle_type.title + ")",
                });
              } else if (roaster.type == 2) {
                // driver

                check[0].driver_roasters.push({
                  driver_id: roaster.object_id,
                  driver_name:
                    roaster.object_title +
                    " (" +
                    (Number(roaster.record_type) > 0 ? "F" : "E") +
                    ")",
                });
              } else if (roaster.type == 3) {
                // helper
                check[0].helper_roasters.push({
                  helper_id: roaster.object_id,
                  helper_name:
                    roaster.object_title +
                    " (" +
                    (Number(roaster.record_type) > 0 ? "F" : "E") +
                    ")",
                });
              }
            } else {
              let roasterObj = {};
              roasterObj.id = roaster.id;
              roasterObj.roaster_date = roaster.roaster_date;
              roasterObj.vehicle_roasters = [];
              roasterObj.driver_roasters = [];
              roasterObj.helper_roasters = [];

              if (roaster.type == 1) {
                // vehicle
                let vehicle_type = _.find(vehicleTypes, function (o) {
                  return o.id == roaster.record_type;
                });
                roasterObj.vehicle_roasters.push({
                  vehicle_id: roaster.object_id,
                  registration_number:
                    roaster.object_title + " (" + vehicle_type.title + ")",
                });
              } else if (roaster.type == 2) {
                // driver
                roasterObj.driver_roasters.push({
                  driver_id: roaster.object_id,
                  driver_name:
                    roaster.object_title +
                    " (" +
                    (Number(roaster.record_type) > 0 ? "F" : "E") +
                    ")",
                });
              } else if (roaster.type == 3) {
                // helper
                roasterObj.helper_roasters.push({
                  helper_id: roaster.object_id,
                  helper_name:
                    roaster.object_title +
                    " (" +
                    (Number(roaster.record_type) > 0 ? "F" : "E") +
                    ")",
                });
              }

              roasters2.push(roasterObj);
            }
          });
          console.log(roasters2);
          console.log(roasters2.length);
          setRoasters(roasters2);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const handleRowClick = (id) => {
    navigate(`/rosters/${id}`)
  };

  const handleSearch = () => {
    setRoasters([]);
    showLoading(layoutDispatch);
    Auth.post(`/roaster/roasters`, {
      start_date: moment(startDate).format("YYYY-MM-DD"),
      end_date: moment(endDate).format("YYYY-MM-DD"),
    })
      .then((res) => {
        hideLoading(layoutDispatch);
        if (res.ack) {
          let roasters1 = res.roasters;

          let roasters2 = [];
          roasters1.map((roaster) => {
            let check = roasters2.filter(
              (r) => r.roaster_date == roaster.roaster_date
            );
            if (check.length > 0) {
              if (roaster.type == 1) {
                // vehicle
                let vehicle_type = _.find(vehicleTypes, function (o) {
                  return o.id == roaster.record_type;
                });
                check[0].vehicle_roasters.push({
                  vehicle_id: roaster.object_id,
                  registration_number:
                    roaster.object_title + " (" + vehicle_type.title + ")",
                });
              } else if (roaster.type == 2) {
                // driver
                check[0].driver_roasters.push({
                  driver_id: roaster.object_id,
                  driver_name:
                    roaster.object_title +
                    " (" +
                    (Number(roaster.record_type) > 0 ? "F" : "E") +
                    ")",
                });
              } else if (roaster.type == 3) {
                // helper
                check[0].helper_roasters.push({
                  helper_id: roaster.object_id,
                  helper_name:
                    roaster.object_title +
                    " (" +
                    (Number(roaster.record_type) > 0 ? "F" : "E") +
                    ")",
                });
              }
            } else {
              let roasterObj = {};
              roasterObj.id = roaster.id;
              roasterObj.roaster_date = roaster.roaster_date;
              roasterObj.vehicle_roasters = [];
              roasterObj.driver_roasters = [];
              roasterObj.helper_roasters = [];

              if (roaster.type == 1) {
                // vehicle
                let vehicle_type = _.find(vehicleTypes, function (o) {
                  return o.id == roaster.record_type;
                });
                roasterObj.vehicle_roasters.push({
                  vehicle_id: roaster.object_id,
                  registration_number:
                    roaster.object_title + " (" + vehicle_type.title + ")",
                });
              } else if (roaster.type == 2) {
                // driver
                roasterObj.driver_roasters.push({
                  driver_id: roaster.object_id,
                  driver_name: roaster.object_title,
                });
              } else if (roaster.type == 3) {
                // helper
                roasterObj.helper_roasters.push({
                  helper_id: roaster.object_id,
                  helper_name: roaster.object_title,
                });
              }

              roasters2.push(roasterObj);
            }
          });
          console.log(roasters2);
          console.log(roasters2.length);
          setRoasters(roasters2);
        } else {
            showMessage('error', res?.message);

        }
      })
      .catch((err) => {
        console.log(err);
            showMessage('error', 'something went wrong');

      });
  };

  return (
    <div>
      <h2 style={{ marginBottom: '10px', marginTop: 0 }}>Rosters</h2>
      <Grid container rowSpacing={2} columnSpacing={1.5}>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={1.5}>
          <label htmlFor="pcnDate">Start Date:</label>
          <AntDate
            format={DATE_FORMAT}
            style={{ width: '100%' }}
            size="large"
            value={startDate ? dayjs(startDate) : null}
            onChange={(date) => {
              const nativeDate = date ? date.toDate() : null;
              setStartDate(nativeDate);
            }}
            placeholder="Select Start Date"
            allowClear={false}

          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={1.5}>
          <label htmlFor="pcnDate">End Date:</label>
          <AntDate
            format={DATE_FORMAT}
            style={{ width: '100%' }}
            size="large"
            value={endDate ? dayjs(endDate) : null}
            onChange={(date) => {
              const nativeDate = date ? date.toDate() : null;
              setEndDate(nativeDate);
            }}
            placeholder="Select End Date"
            allowClear={false}

          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={1}>
          <AntButton
            type="primary"
            size="large"
            onClick={handleSearch}
            style={{ marginLeft: '5px', marginTop: "22px" }}
            icon={<SearchOutlined />}
          >
            Search
          </AntButton>

        </Grid>
      </Grid>
          <div className={classes.antAddIcon}>
            <PlusCircleFilled style={{ fontSize: "30px", color: "#1677FF", float: 'right', marginBottom: '10px' }} onClick={() => navigate("/rosters/new")} />
          </div>
      <Table
        dataSource={roasters}
        // style={{ overflowX: "auto" }}
        scroll={{ x: 'max-content' }}
        columns={roasterColumns}
        pagination={false}
        bordered
        footer={() => `List of Roasters - Total Records: ${roasters.length === 0 ? "0" : roasters.length}`}
      />      
    </div>
  );
}
